import { uuidv7 as generateV7 } from 'uuidv7';

export function uuidv7(): string {
  return generateV7();
}

const UUID_V7_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-7[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function isUuidV7(value: string): boolean {
  return UUID_V7_REGEX.test(value);
}
